import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../utils/cn';

type Variant = 'error';

interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: Variant;
  children: ReactNode;
}

const VARIANTS: Record<Variant, string> = {
  error: 'border-hilevel-red/30 bg-hilevel-red/5 text-hilevel-red',
};

export function Alert({ variant = 'error', className, children, ...rest }: AlertProps) {
  return (
    <div
      role="alert"
      className={cn('rounded-md border px-3 py-2 text-sm', VARIANTS[variant], className)}
      {...rest}
    >
      {children}
    </div>
  );
}
